var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel wraper panel-gray" },
    [
      _c("div", { staticClass: "panel-header" }, [
        _c("div", { staticClass: "panel-title" }, [_vm._m(0)], 1)
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-body", attrs: { id: "formbody" } },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.$v.tempDivision.abbr.$error,
                "error-label": _vm._f("errorLabel")(_vm.$v.tempDivision.abbr)
              }
            },
            [
              _c("q-input", {
                attrs: { autofocus: true, "float-label": "Назв.сокр-ное" },
                model: {
                  value: _vm.tempDivision.abbr,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempDivision,
                      "abbr",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempDivision.abbr"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { "float-label": "Название" },
                model: {
                  value: _vm.tempDivision.fullName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempDivision,
                      "fullName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempDivision.fullName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { "float-label": "Адрес" },
                model: {
                  value: _vm.tempDivision.address,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempDivision,
                      "address",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempDivision.address"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { type: "textarea", rows: 1, "float-label": "Контакты" },
                model: {
                  value: _vm.telString,
                  callback: function($$v) {
                    _vm.telString = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "telString"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { type: "textarea", rows: 1, "float-label": "Заметки" },
                model: {
                  value: _vm.tempDivision.comment,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempDivision,
                      "comment",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempDivision.comment"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("save-btn", {
        attrs: {
          notChanged: _vm.notChanged,
          goView: _vm.goView,
          doSave: _vm.doSave
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("unit-path", {
      attrs: { id: _vm.iniDivision.parent_id, lbl: _vm.lbl }
    })
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4116672c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4116672c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/division-edit.vue
// module id = null
// module chunks = 